
export class Email {

    id: number;
    mittente: string;
    cc: string;
    oggetto: string;
    testo: string;
    punti: string;
    tipo: string;
    pulsanti: String;

}


// WEBPACK FOOTER //
// ./src/app/theme/pages/default/cybersecurity/_model/Email.ts